import Api from "../index";
import { endPoints, requestType } from "../../constants/variables";

// Login api

export const loginUser = (params) => {
  return Api(endPoints.loginResturant, params, requestType.POST);
};

// Restaurant Register
export const registerUser = (params) => {
  return Api(endPoints.signupRestaurant, params, requestType.POST);
};

export const getAllRestaurants = (params) => {
  return Api(endPoints.getAllRestaurants, null, requestType.GET);
};

export const getAdmin = (params) => {
  return Api(endPoints.getAdminDetails, null, requestType.GET);
};

export const updateRestStatus = (params) => {
  return Api(endPoints.updateRestaurantStatus, params, requestType.PUT);
};

export const changePasswordUser = (params) => {
  return Api(endPoints.changeRestaurantPassword, params, requestType.POST);
};

export const deliveryCharges =(params)=>{
  return Api(endPoints.updateDeliveryCharges,params,requestType.POST)
}

export const sendCode =(params)=>{
  return Api(endPoints.forgotRestCode,params,requestType.POST)
}

export const forgotPassword =(params)=>{
  return Api(endPoints.resetRestPassword,params,requestType.POST)
}



